// notificationToggle.js

export function toggleNotificationUI() {
    const iconNotification = document.querySelector("#icon-notification-side-nav");
    const iconNotificationHeader = document.querySelector("#notification-on");

    if (!iconNotification || !iconNotificationHeader) return;

    const isNotification = localStorage.getItem("notificationOn") === "true";

    if (isNotification) {
        iconNotification.classList.add("notification-on");
        iconNotificationHeader.classList.add("notification-on");
    } else {
        iconNotification.classList.remove("notification-on");
        iconNotificationHeader.classList.remove("notification-on");
    }
}